import { Dispatch } from 'react';
import { AnyAction } from '@reduxjs/toolkit';
import { generateSquareGridDataObjectsInRegion } from '../../../../../../core/utils/map.utils';
import iranPolygonGeoJson from '../../../../../../data/iran-polygon.geojson';
import { setCountryGridCoordinates } from '../../../../../../app/redux/slices/countryGridCoordinatesSlice';

export const generateGridForGridCellService = (dispatch: Dispatch<AnyAction>) => {
    var gridCellsRegion = iranPolygonGeoJson.features[0].geometry.coordinates[0];
    const generatedCountryMainGrid = gridCellsRegion && generateSquareGridDataObjectsInRegion(gridCellsRegion, 5000);
    if (generatedCountryMainGrid.success) {
        generatedCountryMainGrid && dispatch(setCountryGridCoordinates(generatedCountryMainGrid.generatedGridCellsData));
    }
};
// var gridCellIdsToCheck: number[] = [39753, 39754, 39755, 40000, 40001, 40002, 40246, 40247, 40248];

// var cellsContainingPolygon: number[] = [];
// var polygonToCheck = [
//     [32.95769522732782, 55.65077403115006],
//     [33.00266124551405, 55.65077403115006],
//     [33.00266124551405, 55.700462378102635],
//     [32.95769522732782, 55.700462378102635],
//     [32.95769522732782, 55.65077403115006],
//     // [32.965, 55.66],
//     // [32.995, 55.66],
//     // [32.995, 55.69],
//     // [32.965, 55.69],
//     // [32.965, 55.66],
// ]; //     generatedCountryMainGrid.generatedGridCellsData.forEach((cell: any) => {
//         if (
//             booleanOverlap(polygon([cell.coordinates]), polygon([polygonToCheck])) ||
//             booleanWithin(polygon([polygonToCheck]), polygon([cell.coordinates]))
//         ) {
//             cellsContainingPolygon.push(cell.id);
//         }
//     });
// var result = gridCellIdsToCheck.every((cellId) => cellsContainingPolygon.includes(cellId));
// console.log('result: ', result);
// } else if (gridCellsRegion) {
//     toast.error(
//         'تعداد نقاط ایجاد شده فراتر از مقدار ممکن برای تولید شبکه است. لطفا فاصله بین نقاط را بیشتر کنید یا منطقه کوچکتری را انتخاب کنید',
//     );
// }
